// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"popup_wrapper__3SJrY","box":"popup_box__3c8Rn","header":"popup_header__2E5IV","title":"popup_title__2SYDr","close":"popup_close__3yLSK","body":"popup_body__ktpkX"};